import { observer } from "mobx-react-lite";
import React from "react";
import { EntryBox } from "./EntryBox";
import { EntryLink } from "./EntryLink";

export const NavLink = observer(
  React.forwardRef<HTMLDivElement, React.ComponentProps<typeof EntryLink>>((props, ref) => {
    return (
      <EntryBox ref={ref} selected={false}>
        <EntryLink {...props} />
      </EntryBox>
    );
  })
);
